import React from 'react'
import './styles.scss'

const scrollTo = (id: string) => {
  let el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  }
}

const content = [
  {
    id: 'intro',
    num: 0,
    label: 'Einleitung'
  },
  {
    id: 'insects',
    num: 1,
    label: 'Insekten'
  },
  {
    id: 'invitro',
    num: 2,
    label: 'In-vitro-Fleisch'
  },
  {
    id: 'algen',
    num: 3,
    label: 'Mikroalgen'
  }
]

const Entry = ({
  id,
  num,
  label,
  small = false
}: {
  id: string
  num: number
  label: string
  small?: boolean
}) => {
  return (
    <div className='entry' onClick={() => scrollTo(id)}>
      {/* {(num || num === 0) && <div className='number'>{num}</div>} */}
      {(num || num === 0) && (
        <div className='icon'>
          <img src={require('./icon_' + id + '.png')} />
        </div>
      )}
      {label && <div className='title'>{label}</div>}
      {/* {!small && num !== 0 && (
        <div className='img'>
          <img src={require('images/' + id + '_sm.png')} />
        </div>
      )} */}
    </div>
  )
}

export const Menu = ({
  small = false,
  hide = []
}: {
  small?: boolean
  hide?: string[]
}) => {
  return (
    <div className='Menu'>
      {' '}
      {content.map(m => {
        return (
          <>
            {hide.indexOf(m.id) === -1 && (
              <Entry id={m.id} label={m.label} num={m.num} small={small} />
            )}
          </>
        )
      })}{' '}
      <div className='info'>Anklicken, um direkt zum Kapitel zu springen.</div>
    </div>
  )
}
